import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryKeysDefinition } from "@chemaxon/terminus-client/types/queryKeys";
import Api from "@chemaxon/terminus-client/ui/services/Api";
import { PermissionMap } from "@chemaxon/terminus-client/ui/models/Permission";
import queryClient from "@chemaxon/terminus-client/ui/utils/queryClient";

export const SERVICE_URL = "/internal/permissions";

class PermissionService {
  static getPermissions(): Promise<PermissionMap> {
    return Api.get(SERVICE_URL);
  }
}

const QUERY_KEYS_NAMESPACE = "permissions";

const baseQueryKeys = {
  all: () => [QUERY_KEYS_NAMESPACE] as const,
  list: () => [QUERY_KEYS_NAMESPACE, "list"] as const,
} satisfies QueryKeysDefinition;

export const queryKeys = {
  ...baseQueryKeys,
} satisfies QueryKeysDefinition;

export const getPermissionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.list(),
    queryFn: () => PermissionService.getPermissions(),
  });

export const useGetPermissions = () => useQuery(getPermissionsQueryOptions());

queryClient.setQueryDefaults(queryKeys.list(), {
  staleTime: Infinity,
});

export default PermissionService;
